/**
 * Auth0 configuration
 * This file contains the configuration for Auth0
 */

export const auth0Config = {
  domain: process.env.GATSBY_AUTH0_DOMAIN || '',
  clientId: process.env.GATSBY_AUTH0_CLIENT_ID || '',
  clientSecret: process.env.GATSBY_AUTH0_CLIENT_SECRET || '',
  callbackUrl: process.env.GATSBY_AUTH0_CALLBACK_URL || 'http://localhost:8000/callback',
  audience: process.env.GATSBY_AUTH0_AUDIENCE || '',
  redirectUri: typeof window !== 'undefined' ? window.location.origin : '',
  // These scopes are required for the application to function properly
  // openid, profile, email: Basic user information
  // read:current_user: Read user metadata
  // update:current_user_metadata: Update user metadata
  scope: 'openid profile email read:current_user update:current_user_metadata',
  responseType: 'code',
  cacheLocation: 'localstorage',
};
